import { Ctx, Mapper } from '../core/types'
import { isEmpty, normalize } from '../core/utils'

// keep the value as provided
export const keepValue = <T>(): Mapper<T> => (v: T) => v

// always return a constant
export const constant = <T>(val: T): Mapper<T> => () => val

// if empty, use fallback
export const defaultIfEmpty = <T>(fallback: T, attribute: string): Mapper<T> =>
    (value: T, ctx: Ctx) =>
        isEmpty(value, attribute, ctx.source) ? fallback : value

// run mappers left-to-right
export const chainMappers = <T>(...fns: Mapper<T>[]): Mapper<T> =>
    (v: any, ctx: Ctx) => fns.reduce((acc, fn) => fn(acc, ctx), v)

// conditionally apply a mapper based on context
export const applyMapperIf = <T>(
    condition: (ctx: Ctx) => boolean,
    mapIfTrue: Mapper<T>,
    mapIfFalse?: Mapper<T>
): Mapper<T> =>
    (v: any, ctx: Ctx) => condition(ctx) ? mapIfTrue(v, ctx) : mapIfFalse ? mapIfFalse(v, ctx) : v

// predicate helpers
export const isSourceIn = (list: string[]) =>
    (ctx: Ctx) => list.includes(normalize(ctx.source))

export const isSource = (source: string) =>
    (ctx: Ctx) => normalize(ctx.source) === normalize(source)